import m from 'mithril';
import {trans, has_permission} from "../helpers";

import Steps from './steps.js';
import SelectTypeahead from '../selectTypeaheadComponent.js';


let challenge_state = require('../new_challenge_creator/challengeState.js');


window.state = challenge_state;

function get_type_id(code) {
    if (Object.keys(challenge_state.challenge_types_code_to_id) == 0)
        return null;

    return challenge_state.challenge_types_code_to_id[code];  
}

function get_type_code(id_type) {
    if (Object.keys(challenge_state.challenge_types_id_to_code) == 0)
        return null;

    return challenge_state.challenge_types_id_to_code[id_type];  
}


function get_challenge_types() {
    if (challenge_state.challenge_types.length == 0) {
        m.request('/api/challenge_types?visibility=public').then(d => {
            challenge_state.challenge_types = d.feed;

            // if (!challenge_state.challenge.id_type) {
            //     challenge_state.challenge.id_type = 1; // only set default if creating new challenge
            // }

            challenge_state.challenge_types_code_to_id = {};

            challenge_state.challenge_types.forEach(type => {
                challenge_state.challenge_types_code_to_id[type.code] = type.id_type; 
                challenge_state.challenge_types_id_to_code[type.id_type] = type.code; 
            });          
        }).catch(err => {
            alert('Something went wrong, please refresh page.')
        })
    }
}

function get_entry_types() {
    if (challenge_state.entry_types.length == 0) {
        m.request('/api/entry_types').then(d => {
            challenge_state.entry_types = d.feed;

            if (!challenge_state.challenge.id_entry_type) {
                challenge_state.challenge.id_entry_type = 1; // only set default if creating new challenge
            }
        }).catch(err => {
            alert('Something went wrong, please refresh page.')
        })
    }
}

function get_groups() {
    m.request('/api/groups?part=items').then(d => {
        challenge_state.groups = d;

        challenge_state.groups.forEach(g => {
            if (!(g.code in challenge_state.challenge.groups)) {
                challenge_state.challenge.groups[g.code] = {
                    id_group: g.id_group*1,
                    list: []
                };
            }
        });

    }).catch(err => {
        alert('Something went wrong, please refresh page.')
    })
}

function get_challenge_type_title(code) {
    let title = '';
    
    if (code == 'time_for_x_rep') {
        title += trans('challenge.time_for_x_rep_msg.how_much') + ' ' +
                  trans('challenge.time_for_x_rep_msg.time') + ' ' +
                  trans('challenge.time_for_x_rep_msg.do_you_need_for') + ' ' + 
                  trans('challenge.time_for_x_rep_msg.specific_number') +
                  '?';
    } else if (code == 'time_for_completion') {
        title += trans('challenge.time_for_completion_msg.how_much') + ' ' +
                  trans('challenge.time_for_completion_msg.time') + ' ' +
                  trans('challenge.time_for_completion_msg.do_you_need_to_complete_this') + ' ' + 
                  trans('challenge.time_for_completion_msg.challenge') +
                  '?';
    } else if (code == 'time_max') {
        title += trans('challenge.time_max_msg.for_how') + ' ' +
                  trans('challenge.time_max_msg.long') + ' ' +
                  trans('challenge.time_max_msg.can_you') + ' ' + 
                  trans('challenge.time_max_msg.go') +
                  '?';
    } else if (code == 'x_rep_in_y_time'){
        title += trans('challenge.x_rep_in_y_time_msg.how_many') + ' ' +
                  trans('challenge.x_rep_in_y_time_msg.repetitions') + ' ' +
                  trans('challenge.x_rep_in_y_time_msg.can_you_do_in') + ' ' + 
                  trans('challenge.x_rep_in_y_time_msg.specific_number') +
                  '?';
    } else if (code == 'x_succcessful_in_y_time'){
        title += trans('challenge.x_succcessful_in_y_time_msg.how_many') + ' ' +
                  trans('challenge.x_succcessful_in_y_time_msg.repetitions') + ' ' +
                  trans('challenge.x_succcessful_in_y_time_msg.can_you_do_in') + ' ' + 
                  trans('challenge.x_succcessful_in_y_time_msg.specific_number') +
                  '?';
    } else if (code == 'x_rep'){
        title += trans('challenge.x_rep_msg.how_many') + ' ' +
                  trans('challenge.x_rep_msg.repetitions') + ' ' +
                  trans('challenge.x_rep_msg.can_you_do') + 
                  '?';
    } else if (code == 'x_result'){
        title += trans('challenge.x_result_msg.what_is') + ' ' +
                  trans('challenge.x_result_msg.your') + ' ' +
                  trans('challenge.x_result_msg.result') + 
                  '?';
    }  else if (code == 'best_result_in_x_tries'){
        title += trans('challenge.best_result_in_x_tries_msg.what_is_your') + ' ' +
                  trans('challenge.best_result_in_x_tries_msg.best') + ' ' +
                  trans('challenge.best_result_in_x_tries_msg.result_in') + ' ' + 
                  trans('challenge.best_result_in_x_tries_msg.specific_number') +
                  '?';
    } else if (code == 'tries_for_x_successful'){
        title += trans('challenge.tries_for_x_successful_msg.how_many') + ' ' +
                  trans('challenge.tries_for_x_successful_msg.tries') + ' ' +
                  trans('challenge.tries_for_x_successful_msg.you_need_for') + ' ' + 
                  trans('challenge.tries_for_x_successful_msg.specific_number') +
                  '?';
    } else if (code == 'passed_didnt_pass'){
        title += trans('challenge.passed_didnt_pass_msg.can_you') + ' ' +
                  trans('challenge.passed_didnt_pass_msg.pass') + ' ' +
                  trans('challenge.passed_didnt_pass_msg.this_challenge') + 
                  '?';
    } else if (code == 'x_persons_in_successful_group'){
        title += trans('challenge.x_persons_in_successful_group_msg.how_many') + ' ' +
                  trans('challenge.x_persons_in_successful_group_msg.students') + ' ' +
                  trans('challenge.x_persons_in_successful_group_msg.is_in_group_that') + ' ' +
                  trans('challenge.x_persons_in_successful_group_msg.successfully') + ' ' + 
                  trans('challenge.x_persons_in_successful_group_msg.completes_challenge') + 
                  '?';
    }

    return title;
}

function get_challenge_variable_type_text(code) {
    let title = '';
    
    if(code == 'time_for_x_rep') {

        title = trans('challenge.number_of_repetitions');
    
    } else if(code == 'x_rep_in_y_time') {
    
        title = trans('challenge.time_in_seconds');
    
    } else if(code == 'x_succcessful_in_y_time') {
    
        title = trans('challenge.time_in_seconds');
    
    } else if(code == 'best_result_in_x_tries') {
    
        title = trans('challenge.number_of_tries');
    
    } else if(code == 'tries_for_x_successful') {
    
        title = trans('challenge.number_of_successful');
    
    } 

    return title;
}

class Overview {
    view() {
        let selected_exercises = challenge_state.challenge.exercises;

        return m('.overview.ijf-form', [
            m('.line', [
                m('.line-element', [
                    m('label', trans('challenge.selected_exercise')),

                    m('.exercise_chooser',
                        selected_exercises.map(e => {
                            return m('.exercise_chooser__split.exercise_chooser__split--included', [
                                m('div.exercise_chooser__img', {
                                    style: 'background-image: url("' + e.url_poster + '")'
                                }),
                                m('div.exercise_chooser__rest', [
                                    m('div.exercise_chooser__title', e.title),
                                    m('div.exercise_chooser__desc', e.short_description),
                                    (e.sports.length > 0) &&
                                    m('div.exercise_chooser__desc', trans('challenge.form.sports').toUpperCase() + ': ' + e.sports.map(s => s.title).join(', ')),
                                ]),
                            ]);
                        })
                    )
                ]),
            ]),
        ])
    }
}

class GroupsSelector {
    view() {
        return m('.groups-selector', [
            challenge_state.groups.map(g => {
                return [
                    // m('label', g.title + ' (' + trans('common.optional').toLowerCase() + ')'),
                    m('label', g.title),
                    challenge_state.challenge.groups[g.code] &&
                    m(SelectTypeahead, {
                        listMode: true,
                        list: g.items,
                        selectedItems: challenge_state.challenge.groups[g.code], // must be object with 'list' atribute (see function: get_groups())
                        placeholder: trans('common.all_age_groups'),
                        dimPlaceholder: false,
                        noResultsText: trans('common.no_results'),
                        getItemText: i => i.title,
                        getItemId: i => i.id_group_item
                    })
                ]
            })
        ]);
    }
}

class SportsSelector {
    getSportsData(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/sports?order_by=path|asc&query="+query,
        }).then(function(data) {
            data_state.results = data;
            data_state.is_loading = false;
        });
    }

    getSportTitle(sport) {
        return sport.title;
    }

    view() {
        return [
            m('label', trans('challenge.form.sports') + ' (' + trans('common.optional').toLowerCase() + ')'),

            m(SelectTypeahead, {
                listMode: false,
                getData: this.getSportsData,
                selectedItems: challenge_state.challenge.sports, // must be object with 'list' atribute (see function: get_groups())
                placeholder: trans('challenge.take_sports_from_exercises'),
                dimPlaceholder: false,
                noResultsText: trans('common.no_results'),
                getItemText: this.getSportTitle,
                getItemId: s => s.id_sport
            })
        ];
    }
}

class ChallengeForm {
    validate_variables() {
        let problems = {};
        let selected_vars = [];

        if (challenge_state.challenge.id_type == get_type_id("time_for_x_rep")) {
            selected_vars = [
                'x'
            ];
        } else if (challenge_state.challenge.id_type == get_type_id("x_rep_in_y_time")) {
            selected_vars = [
                'y'
            ];
        } else if (challenge_state.challenge.id_type == get_type_id("x_succcessful_in_y_time")) {
            selected_vars = [
                'y'
            ];
        } else if (challenge_state.challenge.id_type == get_type_id("best_result_in_x_tries")) {
            selected_vars = [
                'x'
            ];
        } else if (challenge_state.challenge.id_type == get_type_id("tries_for_x_successful")) {
            selected_vars = [
                'x'
            ];
        } else {
            return problems;
        }

        selected_vars.forEach(v => {
            let val = challenge_state.challenge.data[v];

            if (!val || val == null || val == '' || val == 0) {
                problems[v] = 'required';
            }
        });

        return problems;
    }

    validate_challenge() {        
        let problems = challenge_state.validate_form(challenge_state.challenge_validation, challenge_state.challenge);
        let variables_problems = this.validate_variables();
        
        let problems_num = Object.keys(problems).length;

        let awards_problems_msg = "";
        let variables_problems_msg = "";

        let challenge_type = challenge_state.challenge_types.filter(ct => ct.id_type == challenge_state.challenge.id_type);
        challenge_type = challenge_type.length > 0 ? challenge_type[0] : false;

        for (var key in variables_problems) {
            if (!variables_problems.hasOwnProperty(key)) continue;

            let problem = variables_problems[key];

            let problem_msg = "";

            let p_key = problem.split(":")[0];

            if (p_key == "required") {
                problem_msg = "- " + get_challenge_variable_type_text(challenge_type.code) + " " + trans('challenge.validation.required_for_this_type');
            }

            if (p_key == "min") {
                let p_v = problem.split(":")[1];
                problem_msg = "- " + get_challenge_variable_type_text(challenge_type.code) + " " + trans('challenge.validation.should_be_at_least') + " " + p_v +  " " + trans('challenge.validation.characters_long');
            }

            variables_problems_msg += problem_msg + "\n"; 
        }

        if (problems_num > 0 || variables_problems_msg != "") {
            // let alert_msg = "Cannot continue. Please check following problems:\n";
            let alert_msg = trans('challenge.validation.cannot_continue')+":\n";

            for (var key in problems) {
                if (!problems.hasOwnProperty(key)) continue;

                let problem = problems[key];

                let problem_msg = "";

                let p_key = problem.split(":")[0];

                if (p_key == "required") {
                    problem_msg = trans('challenge.validation.is_required');
                }

                if (p_key == "min") {
                    let p_v = problem.split(":")[1];
                    problem_msg = trans('challenge.validation.should_be_at_least') + " " + p_v + " " + trans('challenge.validation.characters_long');
                }

                alert_msg += "- " + trans('challenge.form.' + key) + " "  + problem_msg + "\n"; 
            }

            alert_msg += variables_problems_msg;

            alert(alert_msg);
            return false;
        }

        return true;
    }

    continue_to_invite(e) {
        let valid = this.validate_challenge();

        if (!valid)
            return;

        
        challenge_state.current_step = 'challenge_visibility';
    }

    get_visibility() {
        if (challenge_state.challenge.public*1 == 1)
            return 0;

        if (challenge_state.challenge.public*1 == 0 && challenge_state.challenge.unlisted*1 == 0)
            return 1;

         if (challenge_state.challenge.public*1 == 0 && challenge_state.challenge.unlisted*1 == 1)
            return 2;
    }

    set_visibility(visibility) {
        if (visibility == 0) {
            challenge_state.challenge.public = 1;
            challenge_state.challenge.unlisted = 0;
        }
        if (visibility == 1) {
            challenge_state.challenge.public = 0;
            challenge_state.challenge.unlisted = 0;
        }
        if (visibility == 2) {
            challenge_state.challenge.public = 0;
            challenge_state.challenge.unlisted = 1;
        }
    }

    view() {
        return m('.ijf-form', [
            m('.line', [
                m('.line-element', [
                    m('label', [
                        trans('challenge.form.title'),
                        m('span.required-asterisk', '*')
                    ]),
                    m('input', {
                        placeholder: trans('challenge.example_title'),
                        type: 'text',
                        value: challenge_state.challenge.title,
                        onchange: e => { challenge_state.challenge.title = e.target.value }
                    })
                ]),
            ]),
            m('.line', [
                m('.line-element', [
                    m('label', [
                        trans('challenge.form.subtitle'),
                    ]),
                    m('input', {
                        placeholder: trans('challenge.example_subtitle'),
                        type: 'text',
                        value: challenge_state.challenge.subtitle,
                        onchange: e => { challenge_state.challenge.subtitle = e.target.value }
                    })
                ]),
            ]),
            // m('.line', [
            //     m('.line-element', [
            //         m('label', [
            //             trans('challenge.form.description'),
            //             // m('span.required-asterisk', '*')
            //         ]),
            //         m('input', {
            //             placeholder: trans('challenge.example_description'),
            //             type: 'text',
            //             value: challenge_state.challenge.description,
            //             onchange: e => { challenge_state.challenge.description = e.target.value }
            //         })
            //     ]),
            // ]),
            // m('.line.line--with-explainer', [
            m('.line', [
                m('.line-element', [
                    m('label', [
                        trans('challenge.form.starts_at'),
                        // m('span.required-asterisk', '*')
                    ]),
                    m('input', {
                        type: 'date',
                        value: challenge_state.challenge.starts_at,
                        min: new Date().toISOString().split("T")[0],
                        onchange: e => { challenge_state.challenge.starts_at = e.target.value }
                    })
                ]),

                m('.line-element', [
                    m('label', [
                        trans('challenge.form.ends_at'),
                        // m('span.required-asterisk', '*')
                    ]),
                    
                    (challenge_state.set_ends_at || challenge_state.challenge.ends_at) &&
                    m('input', {
                        type: 'date',
                        min: challenge_state.challenge.starts_at,
                        value: challenge_state.challenge.ends_at,
                        onchange: e => { challenge_state.challenge.ends_at = e.target.value }
                    }),

                    (!challenge_state.set_ends_at && !challenge_state.challenge.ends_at) &&
                    [
                        m('.ends-at-helper', [
                            m('span', trans('challenge.doesnt_end_text') + '. '),
                            m('span.link', {
                                onclick: e => challenge_state.set_ends_at = true
                            }, trans('challenge.set_ends_at'))
                        ])
                    ] 
                ])
            ]),
            // m('.line__explainer',
            //     (!challenge_state.set_ends_at && !challenge_state.challenge.ends_at) && 
            //     m('.link', {
            //         onclick: e => challenge_state.set_ends_at = true
            //     }, trans('challenge.set_ends_at'))
            // ),

            m('.line', [
                m('.line-element', [
                    m('label', [
                        trans('challenge.select_entry_type'),
                    ]),
                    m('select', {
                        value: challenge_state.challenge.id_entry_type,
                        onchange: e => challenge_state.challenge.id_entry_type = e.target.value*1
                    }, challenge_state.entry_types.map(_t => {
                        return m('option', {
                            selected: challenge_state.challenge.id_entry_type == _t.id_entry_type,
                            value: _t.id_entry_type
                        }, trans('challenge.select_entry_type.'+_t.code))
                    }))
                ]),
            ]),
            m('.line .line--with-explainer', [
                m('.line-element', [
                    m('label', [
                        trans('challenge.select_type'),
                        m('span.required-asterisk', '*')
                    ]),
                    m('select', {
                        value: challenge_state.challenge.id_type,
                        onchange: e => challenge_state.challenge.id_type = e.target.value*1
                    }, 
                        m('option', { value: 0 }, trans('challenge.select_challenge_type')),
                        challenge_state.challenge_types.map(_t => {
                            return m('option', {
                                selected: challenge_state.challenge.id_type == _t.id_type,
                                value: _t.id_type
                            }, get_challenge_type_title(_t.code))
                        })
                    )
                ]),
                m(TypeSelectorVars),
            ]),
            m('.line__explainer', 
                (challenge_state.challenge.id_type > 0 && get_type_code(challenge_state.challenge.id_type)) &&
                [
                    trans('challenge.' + get_type_code(challenge_state.challenge.id_type) + '.explainer')
                ]
            ),


            m('.line', [
                m('.line-element', [
                    m(GroupsSelector),
                ]),

                m('.line-element', [
                    m(SportsSelector),
                ]),
            ]),

            // m('.line', [
            //     m('.line-element', [
            //         m('label', [
            //             trans('exercises.form.visibility'),
            //         ]),
            //         m('select', {
            //             value: this.get_visibility(),
            //             onchange: e => this.set_visibility(e.target.value*1)
            //         }, [
            //             m('option', {
            //                 value: 0,
            //                 selected: this.get_visibility() == 0
            //             }, trans('common.public')),
            //             m('option', {
            //                 value: 1,
            //                 selected: this.get_visibility() == 1
            //             }, trans('common.private')),
            //             m('option', {
            //                 value: 2,
            //                 selected: this.get_visibility() == 2
            //             }, trans('common.unlisted'))
            //         ])
            //     ])
            // ]),

            m('.line', [
                has_permission('challenges.canInsertEntryToAnyone') &&
                m('.line-element', [
                    m('label', [
                        trans('challenge.form.exposed'),
                    ]),
                    m('select', {
                        value: challenge_state.challenge.exposed,
                        onchange: e => challenge_state.challenge.exposed = e.target.value*1
                    }, [
                        m('option', {
                            value: 0,
                            selected: challenge_state.challenge.exposed == 0
                        }, trans('common.no')),
                        m('option', {
                            value: 1,
                            selected: challenge_state.challenge.exposed == 1
                        }, trans('common.yes'))
                    ])
                ]),

                has_permission('challenges.canInsertToSst') &&
                m('.line-element', [
                    m('label', [
                        trans('challenge.form.is_sst'),
                    ]),
                    m('select', {
                        value: challenge_state.challenge.is_sst,
                        onchange: e => challenge_state.challenge.is_sst = e.target.value*1
                    }, [
                        m('option', {
                            value: 0,
                            selected: challenge_state.challenge.is_sst == 0
                        }, trans('common.no')),
                        m('option', {
                            value: 1,
                            selected: challenge_state.challenge.is_sst == 1
                        }, trans('common.yes'))
                    ])
                ])
            ]),

            // has_permission('challenges.canInsertToSst') &&
            // m('.line', [
            //     m('.line-element', [
            //         m('label', [
            //             trans('challenge.form.is_sst'),
            //         ]),
            //         m('select', {
            //             value: challenge_state.challenge.is_sst,
            //             onchange: e => challenge_state.challenge.is_sst = e.target.value*1
            //         }, [
            //             m('option', {
            //                 value: 0,
            //                 selected: challenge_state.challenge.is_sst == 0
            //             }, trans('common.no')),
            //             m('option', {
            //                 value: 1,
            //                 selected: challenge_state.challenge.is_sst == 1
            //             }, trans('common.yes'))
            //         ])
            //     ])
            // ]),

            // m(Awards),
            m('.buttons-line',
                m('.btn', {
                    type: 'submit',
                    onclick: e => { challenge_state.current_step = 'select_exercises'}
                }, trans('common.go_back')),
                // }, trans('challenge.back_to_previous_step_btn')),
                m('.btn.btn--full-width.btn--main', {
                    type: 'submit',
                    onclick: e => {
                        this.continue_to_invite(e);
                    }
                }, trans('challenge.continue_btn'))
            )
        ])
    }
}

class TypeSelectorVars {
    view() {
        let vars = []
        let code = '';

        if (challenge_state.challenge.id_type == get_type_id("time_for_x_rep")) {
            vars = [
                'x'
            ];
            code = "time_for_x_rep";
        } else if (challenge_state.challenge.id_type == get_type_id("x_rep_in_y_time")) {
            vars = [
                'y'
            ];
            code = "x_rep_in_y_time";
        } else if (challenge_state.challenge.id_type == get_type_id("x_succcessful_in_y_time")) {
            vars = [
                'y'
            ];
            code = "x_succcessful_in_y_time";
        } else if (challenge_state.challenge.id_type == get_type_id("best_result_in_x_tries")) {
            vars = [
                'x'
            ];
            code = "best_result_in_x_tries";
        } else if (challenge_state.challenge.id_type == get_type_id("tries_for_x_successful")) {
            vars = [
                'x'
            ];
            code = "tries_for_x_successful";
        }
        

        return vars.map(_v => {
            return m('.line-element', [
                m('label', [
                    // trans('challenge.variable') + ' ' + _v,
                    get_challenge_variable_type_text(code),
                    m('span.required-asterisk', '*')
                ]),
                m('input', {
                    // placeholder: _v,
                    type: 'number',
                    value: challenge_state.challenge.data[_v] ? challenge_state.challenge.data[_v] : '',
                    onchange: _dom => challenge_state.challenge.data[_v] = _dom.target.value
                })
            ])
        })
    }
}

class CreateChallenge {
    oninit() {
        get_challenge_types();
        get_entry_types();
        get_groups();
    }
    go_back(e) {
        challenge_state.current_step = 'select_exercise';
    }
    view() {
        return [
            m(Steps),
            m('h2', trans('challenge.challenge_details')),
            m(Overview),
            m(ChallengeForm)
        ]
    }
}

export default CreateChallenge;